import { i18n, sprintf } from '@/common/utils/i18n'
import ruleConfig from './rules-DO'
import {isString} from 'lodash-es'
console.log('use parser-DO')
const DEFAULTS = {
  i18n: {
    ...i18n,
    sprintf
  }
}

// const parse = rule => rule.split('|').map(x => x.trim())

// format:
// [['required', _('电话号码')], ['maxLength', _('公司地址'), 10]]
const create = config => rulesArr =>
  rulesArr.reduce(
    (red, rule) => {
      let { rules, messages } = red
      const [name, errMessage, ...payload] = isString(rule) ? [rule] : rule
      const { i18n } = config

      if (ruleConfig[name]) {
        const parsed = ruleConfig[name](errMessage, i18n, payload)
        rules = { ...rules, ...parsed.rules }
        messages = { ...messages, ...parsed.messages }
        red = { rules, messages }
      }
      return red
    },
    { rules: {}, messages: {} }
  )

export function init (config) {
  return create({ ...DEFAULTS, ...config })
}

export default create(DEFAULTS)
